import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { appApi } from '../../../utils/endpoints/appApi';
import { handleApiRejection } from '../../../utils/lib';

import http from '../../../services/http';

export const getStaffAction = createAction('notap/getStaff');
export const sendLetterAction = createAction('notap/sendLetter');

export const getStaffList = createAsyncThunk(getStaffAction.type, async () => {
    const response = await http.get(appApi.getStaff);
    return response.data;
});

export const sendLetter = createAsyncThunk(sendLetterAction.type, async (formData, thunkApi) => {
    try {
        const response = await http.post(appApi.sendLetter, formData);
        return response.data;
    } catch (error) {
        return thunkApi.rejectWithValue(handleApiRejection(error));
    }
});
